<template>
    <v-toolbar color="#2B3848" dark class="fixed-bar">
        <v-icon class="mr-4">{{ icon }}</v-icon>
        <v-toolbar-title v-if="organization || showOrganizationSlot" class="mr-4 d-flex flex-column">
            <span v-if="organization" class="font-weight-thin text-caption">{{ organization }}</span>
            <div class="d-flex align-center">
                <span class="font-weight-thin mr-1">{{ title }} |</span>

                <v-tooltip bottom v-if="editable && !editing" color="black">
                    <template v-slot:activator="{ on, attrs }">
                        <span v-on="on" v-bind="attrs" @click="startEditing()" class="editable">{{ model }}</span>
                    </template>
                    <span>{{ tooltip }}</span>
                </v-tooltip>

                <span v-if="!editable">{{ model }}</span>
                <span v-if="subtitle">{{ subtitle }}</span>
            </div>
            <slot name="organization"></slot>
        </v-toolbar-title>
        <v-toolbar-title v-else-if="!editable" class="mr-4 d-flex flex-column align-center">
            <span class="d-flex">
                <span class="font-weight-thin">{{ title }} |</span>
                <span v-if="model" class="ml-1">{{ model }}</span>
                <span class="ml-1">{{ subtitle }}</span>
            </span>
        </v-toolbar-title>
        <v-toolbar-title v-else class="mr-4">
            <span class="font-weight-thin">{{ title }} |</span>

            <v-tooltip v-if="editable && !editing" bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs" @click="startEditing()" class="editable">{{ model }}</span>
                </template>
                <span>{{ tooltip }}</span>
            </v-tooltip>

            <span v-if="!editable">{{ model }}</span>
            <span v-if="subtitle">{{ subtitle }}</span>
        </v-toolbar-title>

        <v-text-field v-if="editing" ref="editToolBarInput" flat solo-inverted hide-details v-model="editText" @keydown.enter="acceptEditedText()" @keydown.esc="cancelEditing()" />
        <v-btn v-if="editing" color="green" class="ml-4 mr-4" @click="acceptEditedText()">Guardar</v-btn>
        <v-btn v-if="editing" color="red" @click="cancelEditing()">Cancelar</v-btn>

        <template v-if="!editing">
            <slot name="left"></slot>
            <v-spacer v-if="(hasSlot || saving) && !removeSpacer"></v-spacer>
            <slot></slot>

            <v-container style="width: 300px" fluid v-if="saving">
                <v-row align-content="center" justify="center" dense>
                    <v-col class="text-subtitle-1 text-center" cols="12">Guardando</v-col>
                    <v-col cols="12">
                        <v-progress-linear color="primary accent-4" indeterminate rounded height="6" />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </v-toolbar>
</template>

<style lang="scss" scoped>
.fixed-bar {
    position: sticky !important;
    position: -webkit-sticky !important; /* for Safari */
    /* top: 64px !important; */
    top: 0px !important;
    width: 100% !important;
    z-index: 3 !important;
}

.editable {
    cursor: pointer;
    padding: 2px;
    border: 1px solid transparent;
    &:hover {
        border: 1px dotted white;
    }
}
</style>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
    $refs!: {
        editToolBarInput: HTMLInputElement;
    };

    editing = false;
    editText = "";

    @Prop({ default: "" })
    icon?: string;

    @Prop({ default: "Sin título" })
    title?: string;

    @Prop({ default: null, type: String, required: false })
    subtitle?: string;

    @Prop({ default: null, type: String, required: false })
    organization?: string;

    @Prop({ default: "Pulsa para cambiar el nombre" })
    tooltip?: string;

    @Prop({ default: "", type: String })
    model!: string;

    @Prop({ default: false, type: Boolean })
    editable?: boolean;

    @Prop({ default: false, type: Boolean })
    removeSpacer?: boolean;

    @Prop({ default: false, type: Boolean })
    showOrganizationSlot?: boolean;

    @Prop({ default: false, type: Boolean })
    saving?: boolean;

    // @Watch("searchText")
    // updateSearchText(value: string) {
    //     this.$emit("searchTextChanged", value);
    // }

    get hasSlot(): boolean {
        const name = "default";
        return !!this.$slots[name] || !!this.$scopedSlots[name];
    }

    startEditing() {
        this.editText = this.model || "";
        this.editing = true;

        this.$nextTick(() => {
            this.$refs?.editToolBarInput?.focus();
        });
    }

    acceptEditedText() {
        if (this.editText !== this.model) {
            this.$emit("modelChanged", this.editText);
        }

        this.editing = false;
    }

    cancelEditing() {
        this.editing = false;
    }
}
</script>
